export default __webpack_public_path__ + "static/media/services.93e0c797.svg";